// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","525":"articles","631":"contact"}[chunkId] + "." + {"443":"fce156e3","525":"314e104f","631":"cc960ae7"}[chunkId] + ".css";
};